module.exports = __webpack_public_path__ + "img/botabib.cd68fb89.svg";